import React from "react";
import { NavLink } from "react-router-dom";

const SharedPageHeader = ({
  title,
  Icon,
  iconSize,
  onIconClick = () => {},
  children,
  tabs = [],
  className,
  iconClass,
  subtitle,
}) => {
  return (
    <div
      className={`pb-3 flex flex-col gap-2 md:flex-row md:items-center md:justify-between ${className}`}
    >
      <div className="flex items-center">
        {Icon && (
          <div className="icon-bg-container me-2">
            <Icon
              size={iconSize}
              className={`text-iconC cursor-pointer ${iconClass}`}
              onClick={onIconClick}
            />
          </div>
        )}
        {/* <h3 className="text-darkBg  text-[16px] md:text-[18px] lg:text-[20px] font-[600]">
          {title}
        </h3> */}
        <div className="flex items-center gap-1">
          <h3 className="text-darkBg  text-[16px] md:text-[18px] lg:text-[20px] font-[600]">
            {title}
          </h3>

          {subtitle && (
            <span className="text-xs md:text-sm text-gray-500 font-[500] italic">
              ({subtitle})
            </span>
          )}
        </div>
        {tabs.length > 0 && <PageTabs tabs={tabs} />}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
};

const PageTabs = ({ tabs }) => {
  return (
    <div className="ms-4 md:ms-8">
      <div className="flex items-center gap-x-8">
        {tabs?.map((data, index) => (
          <div key={index}>
            <NavLink
              to={data?.link}
              className="text-[14px] text-gray font-[500] active-page-link"
            >
              {data?.title}
            </NavLink>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SharedPageHeader;
